import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Button from '../../components/ui/Button';
import SectionTitle from '../../components/common/SectionTitle';
import { fadeInUp, delayTransition, enhancedViewport, simpleTransition } from '../../utils/animation';
import './HomeAbout.scss';

// Imagine placeholder
const NUT_IMAGE_1 = '/images/nut-1.png';



const HomeAbout = () => {
  const { t } = useTranslation('home');
  
  // CLEANED: Eliminat useAnimation() și useEffect() overhead
  
  // OPTIMIZAT: Folosim fadeInUp din utils/animation.js în loc de textVariants duplicat
  
  // Animație specială pentru imagine
  const imageVariants = {
    hidden: { 
      opacity: 0, 
      x: 100, 
      rotateY: 25,
      scale: 0.8
    },
    visible: { 
      opacity: 1, 
      x: 0, 
      rotateY: 0,
      scale: 1,
      transition: { 
        type: 'spring', 
        stiffness: 50, 
        damping: 20, 
        duration: 1 
      }
    }
  };
  
  return (
    <section className="section intro">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={simpleTransition}
          viewport={enhancedViewport}
        >
          <SectionTitle>{t('about.sectionTitle')}</SectionTitle>
        </motion.div>
        
        <div className="intro__content">
          <motion.div
            className="intro__text"
            initial="hidden"
            whileInView="visible"
            viewport={enhancedViewport}
            variants={fadeInUp}
          >
            <motion.h3
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={delayTransition(0.2)}
              viewport={enhancedViewport}
            >
              {t('about.title')}
            </motion.h3>
            
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={delayTransition(0.4)}
              viewport={enhancedViewport}
            >
              {t('about.paragraph1')}
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={delayTransition(0.6)}
              viewport={enhancedViewport}
            >
              {t('about.paragraph2')}
            </motion.p>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={delayTransition(0.8)}
              viewport={enhancedViewport}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Button 
                to="/despre-noi"
                type="primary"
                as="link"
              >
                {t('about.button')}
              </Button>
            </motion.div>
          </motion.div>
          <motion.div
            className="intro__image"
            initial="hidden"
            whileInView="visible"
            viewport={enhancedViewport}
            variants={imageVariants}
            whileHover={{ 
              scale: 1.05, 
              boxShadow: '0 30px 60px rgba(0,0,0,0.2), 0 15px 30px rgba(0,0,0,0.15)', 
              rotateY: -5,
              transition: simpleTransition
            }}
          >
            <img src={NUT_IMAGE_1} alt="Nuci de calitate" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
